module.exports = __webpack_public_path__ + "ea5d6916ae244a1c.png";